// packages
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// assets
import "swiper/css";

// components
import StandardContainer from "./StandardContainer";

export default function BigSlider({ data }) {
  const content = (
    <div className="">
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{
          delay: 2500,
        }}
        loop={true}
        slidesPerView={3}
        slidesPerGroup={3}
        spaceBetween={20}
        speed={1500}
        pagination={{
          enabled: true,
          clickable: true,
          dynamicBullets: true,
        }}
        breakpoints={{
          320: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 20,
          },
        }}
        style={{
          "--swiper-pagination-color": "#404040",
          "--swiper-pagination-bullet-inactive-color": "#c6a58e",
          "--swiper-pagination-bullet-size": "1rem",
          "--swiper-pagination-bullet-border-radius": "0",
        }}
      >
        {data.slice(0, 15).map((item, idx) => (
          <SwiperSlide
            key={idx}
            className="!h-[100%]"
          >
            <img
              className="size-full object-contain"
              src={item.image}
              alt=""
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );

  return <StandardContainer content={content} />;
}
